module.exports = __webpack_public_path__ + "static/media/up-right-from-square-solid.807c3e50.svg";